__turbopack_context__.v({
  "ryanairBannerContainer": "HI_oEa_ryanairBannerContainer",
});
